import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { instanceAPIMember } from 'config/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const subscribeNewsletter = createAsyncThunk(
  'newsletter',
  async (valores) => {
    const newsletterNotify = await instanceAPIMember.post('/preference/subscribe', valores, axiosConfig)
      .then((resp) => resp.data)
      .catch((err) => err.response);
    return newsletterNotify;
  },
);

const newsletterSlice = createSlice({
  name: 'newsletter',
  initialState: {
    newsletter: {},
    newsletterStatus: '',
  },
  extraReducers: {
    [subscribeNewsletter.pending]: (state) => {
      state.newsletterStatus = 'loading';
    },
    [subscribeNewsletter.fulfilled]: (state, action) => {
      state.newsletterStatus = 'success';
      state.newsletter = action.payload;
    },
    [subscribeNewsletter.rejected]: (state, action) => {
      state.newsletterStatus = 'error';
      state.newsletter = action.payload;
    },
  },
});

export default newsletterSlice.reducer;
